import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Event from '@material-ui/icons/Event';
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import enLocale from 'date-fns/locale/en-US';
import jaLocale from 'date-fns/locale/ja';
import * as React from 'react';
import i18next from '../resources/i18n';
import LocalizedUtils from '../utils/LocatizedUtils';
interface IMyProps {
	label?: string;
	helperText?: string;
	name: string;
	onChange: (name: string, date: string) => void;
	value: string;
	disabled?: boolean;
}

interface IProps extends React.Props<{}>, IMyProps {}

interface IState {
	date: Date | null;
}

/**
 * DatePickerコンポーネント
 */
export default class CustomDatePicker extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		let value = null;
		if (this.props.value !== '' && this.props.value !== 'NaN/aN/aN aN:aN') {
			value = new Date(this.props.value);
		}
		this.state = {
			date: value,
		};
		this.onChange = this.onChange.bind(this);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (this.props.value !== prevProps.value) {
			if (this.props.value !== '') {
				const date = new Date(this.props.value);
				this.setState({
					date,
				});
			} else {
				this.setState({
					date: null,
				});
			}
		}
	}

	public render() {
		let Locale = jaLocale;
		if (i18next.language === 'en') {
			Locale = enLocale;
		}
		return (
			<MuiPickersUtilsProvider utils={LocalizedUtils} locale={Locale}>
				<KeyboardDatePicker
					label={this.props.label}
					helperText={this.props.helperText}
					format="yyyy/MM/dd"
					value={this.state.date}
					onChange={this.onChange}
					leftArrowIcon={<ArrowBack />}
					rightArrowIcon={<ArrowForward />}
					keyboardIcon={<Event />}
					clearable={true}
					okLabel={i18next.t('CustomDatePicker_0001')}
					cancelLabel={i18next.t('CustomDatePicker_0002')}
					clearLabel={i18next.t('CustomDatePicker_0003')}
					disabled={this.props.disabled}
					style={{ width: '200px' }}
				/>
			</MuiPickersUtilsProvider>
		);
	}

	/**
	 * 日付変更処理
	 * @param date 日付オブジェクト
	 */
	protected onChange(date: Date) {
		this.setState({
			date,
		});

		let dateStr = '';
		if (date !== null) {
			const newDate = date as Date;
			const YYYY = newDate.getFullYear();
			const MM = ('00' + (newDate.getMonth() + 1)).slice(-2);
			const DD = ('00' + newDate.getDate()).slice(-2);

			dateStr = YYYY + '/' + MM + '/' + DD;
		} else {
			dateStr = '';
		}
		// コールバック実行
		this.props.onChange(this.props.name, dateStr);
	}
}



// WEBPACK FOOTER //
// ./src/components/CustomDatePicker.tsx